import { Link } from "react-router-dom";
import { MapPin, Users, Calendar } from "lucide-react";
import { formatDateShort } from "@/lib/constants";
import { fileUrl } from "@/lib/api";

export default function EventCard({ event, testId }) {
  const { day, month } = formatDateShort(event.start_date);
  const available = event.seats_available;
  const capacity = event.capacity || 0;
  const badge =
    event.status === "completo"
      ? { text: "Posti esauriti", cls: "bg-[#292522]/10 text-[#292522]" }
      : event.status === "annullato"
      ? { text: "Annullato", cls: "bg-red-100 text-red-700" }
      : event.status === "iscrizioni_aperte"
      ? { text: "Iscrizioni aperte", cls: "bg-[#FF6100] text-white" }
      : event.status === "concluso"
      ? { text: "Concluso", cls: "bg-[#F8F1E8] text-[#292522]/70" }
      : { text: "Pubblicato", cls: "bg-[#216B65] text-white" };

  const cover = event.cover_image ? fileUrl(event.cover_image) : null;

  return (
    <Link to={`/eventi/${event.slug}`} className="group card-vv block hover:-translate-y-1 transition-transform duration-300" data-testid={testId}>
      <div className="relative aspect-[4/3] bg-[#FFF1E8] overflow-hidden">
        {cover ? (
          <img src={cover} alt={event.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-40 h-40 blob bg-[#FF6100]/20" />
          </div>
        )}
        <div className="absolute top-4 left-4 rounded-2xl bg-white shadow-sm px-3 py-2 text-center min-w-[64px]">
          <div className="text-2xl font-display font-semibold text-[#FF6100] leading-none">{day}</div>
          <div className="text-[10px] uppercase tracking-widest text-[#292522]/60">{month}</div>
        </div>
        <div className={`absolute top-4 right-4 rounded-full px-3 py-1 text-xs font-semibold ${badge.cls}`}>{badge.text}</div>
      </div>
      <div className="p-6">
        <h3 className="text-xl font-display font-semibold text-[#292522] group-hover:text-[#FF6100] transition-colors">
          {event.title}
        </h3>
        {event.short_desc && <p className="mt-2 text-sm text-[#292522]/70 line-clamp-2">{event.short_desc}</p>}
        <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-[#292522]/60">
          {event.location && <span className="inline-flex items-center gap-1"><MapPin className="h-3.5 w-3.5" strokeWidth={1.75} />{event.location}</span>}
          {capacity > 0 && (
            <span className="inline-flex items-center gap-1"><Users className="h-3.5 w-3.5" strokeWidth={1.75} />{available != null ? `${available} posti liberi` : `${capacity} posti`}</span>
          )}
        </div>
        <div className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[#FF6100]">
          Scopri e prenota
          <span aria-hidden>→</span>
        </div>
      </div>
    </Link>
  );
}
